(function() {
var root = document.querySelector('[data-origin-campaign]');
if (!root) return;

function plural(count, singular, pluralValue) {
return count === 1 ? singular : pluralValue;
}

function panelCounts(panel) {
return {
videos: panel ? panel.querySelectorAll('video').length : 0,
photos: panel ? panel.querySelectorAll('figure img').length : 0
};
}

function isResultPanel(tab, panel) {
var marker = tab.querySelector('.origin-step-marker');
var markerText = marker ? marker.textContent : '';
var title = panel ? panel.querySelector('.origin-step-copy strong') : null;
var titleText = title ? title.textContent : '';
return /result/i.test(markerText) || /result|start to day|2 hours post-treatment/i.test(titleText);
}

function mediaLabel(counts, resultPanel) {
if (counts.videos && counts.photos) {
return (counts.videos > 1 ? 'Videos' : 'Video') + ' + photos';
}
if (counts.videos) return counts.videos > 1 ? 'Videos' : 'Video';
if (counts.photos) return resultPanel ? 'Result photos' : 'Photos';
return 'Details';
}

function activeStepTab(stepper) {
return stepper.querySelector('[data-origin-step-tab].is-active') || stepper.querySelector('[data-origin-step-tab][aria-selected="true"]') || stepper.querySelector('[data-origin-step-tab]');
}

function stepTabText(tab) {
if (!tab) return '';
var first = tab.querySelector('span:first-child');
return first ? first.textContent.trim() : tab.textContent.trim();
}

function stepTabMarker(tab) {
if (!tab) return '';
var marker = tab.querySelector('.origin-step-marker');
return marker ? marker.textContent.trim() : '';
}

function stepGroupText(tab) {
if (!tab) return '';
var group = tab.closest('.origin-step-group');
var label = group ? group.querySelector('.origin-step-group-label') : null;
return label ? label.textContent.trim() : 'Journey timeline';
}

function syncStepLabels() {
root.querySelectorAll('[data-origin-stepper]').forEach(function(stepper) {
stepper.querySelectorAll('[data-origin-step-tab]').forEach(function(tab) {
var id = tab.getAttribute('data-origin-step-tab');
var panel = stepper.querySelector('[data-origin-step-panel="' + id + '"]');
var marker = tab.querySelector('.origin-step-marker');
if (!marker || !panel) return;
marker.textContent = mediaLabel(panelCounts(panel), isResultPanel(tab, panel));
});
});
}

function addAreaNotes() {
root.querySelectorAll('.origin-journey-viewer').forEach(function(viewer) {
var stage = viewer.querySelector('.origin-step-stage');
if (!stage || stage.querySelector('.origin-journey-area-note')) return;
var note = document.createElement('div');
note.className = 'origin-journey-area-note';
note.innerHTML = '<strong>Areas shown: </strong><span>Full face (whole face), eye area (around the eyes / periorbital), jawline and neck.</span>';
stage.appendChild(note);
});
}

function photoSummaryTitle(panel, photos, resultPanel) {
var countText = photos + ' ' + plural(photos, 'photo', 'photos');
return {
title: resultPanel ? 'Result photos' : 'Photos',
hint: 'Flick through and tap any image to enlarge.',
count: countText
};
}

function initPhotoAccordions() {
root.querySelectorAll('[data-origin-step-panel]').forEach(function(panel) {
var grid = panel.querySelector('.origin-step-media-grid');
if (!grid || grid.getAttribute('data-origin-photo-accordion') === 'true') return;
var figures = Array.prototype.slice.call(grid.children).filter(function(child) {
return child.tagName === 'FIGURE';
});
var photoFigures = figures.filter(function(figure) {
return figure.querySelector('img') && !figure.querySelector('video');
});
if (!photoFigures.length) {
grid.setAttribute('data-origin-photo-accordion', 'true');
return;
}
var tab = root.querySelector('[data-origin-step-tab="' + panel.getAttribute('data-origin-step-panel') + '"]');
var summaryText = photoSummaryTitle(panel, photoFigures.length, tab ? isResultPanel(tab, panel) : false);
var details = document.createElement('details');
var summary = document.createElement('summary');
var inner = document.createElement('div');
details.className = 'origin-photo-accordion';
details.open = true;
summary.innerHTML = '<span class="origin-photo-accordion-title"><strong>' + summaryText.title + '</strong><span>' + summaryText.hint + '</span></span><span class="origin-photo-accordion-count">' + summaryText.count + '</span>';
summary.addEventListener('click', function(event) {
event.preventDefault();
details.open = true;
});
inner.className = 'origin-photo-accordion-grid';
photoFigures.forEach(function(figure) {
figure.classList.remove('origin-media-item--hero', 'origin-media-item--wide');
inner.appendChild(figure);
});
details.appendChild(summary);
details.appendChild(inner);
grid.appendChild(details);
grid.setAttribute('data-origin-photo-accordion', 'true');
});
}

function setJourneyDrawerOpen(stepper, open) {
var toggle = stepper.querySelector('[data-origin-step-drawer-toggle]');
stepper.classList.toggle('is-step-drawer-open', !!open);
if (toggle) {
toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
toggle.setAttribute('aria-label', open ? 'Hide treatment day list' : 'View all treatment days');
var icon = toggle.querySelector('[data-origin-step-drawer-icon]');
if (icon) icon.textContent = open ? 'Hide treatment days' : 'View all treatment days';
}
}

function updateJourneyDrawer(stepper) {
var toggle = stepper.querySelector('[data-origin-step-drawer-toggle]');
if (!toggle) return;
var tab = activeStepTab(stepper);
var kicker = toggle.querySelector('[data-origin-step-drawer-kicker]');
var current = toggle.querySelector('[data-origin-step-drawer-current]');
var marker = toggle.querySelector('[data-origin-step-drawer-marker]');
if (kicker) kicker.textContent = 'Currently viewing';
if (current) {
var group = stepGroupText(tab);
var step = stepTabText(tab);
current.textContent = group === 'Results' ? step + ' results' : group + ' - ' + step;
}
if (marker) marker.textContent = stepTabMarker(tab) || 'Details';
}

function initJourneyDrawers() {
root.querySelectorAll('.origin-journey-viewer[data-origin-stepper]').forEach(function(stepper, index) {
if (stepper.getAttribute('data-origin-step-drawer-ready') === 'true') {
updateJourneyDrawer(stepper);
return;
}
var nav = stepper.querySelector('.origin-step-nav');
var stage = stepper.querySelector('.origin-step-stage');
if (!nav || !stage) return;

var modal = stepper.closest('.origin-modal');
if (modal) modal.classList.add('origin-modal--journey-content-first');
stepper.setAttribute('data-origin-content-first', 'true');
stepper.setAttribute('data-origin-step-drawer-ready', 'true');

if (!nav.id) nav.id = 'origin-step-nav-' + index + '-' + Math.random().toString(36).slice(2, 8);

var toggle = document.createElement('button');
toggle.className = 'origin-step-drawer-toggle';
toggle.type = 'button';
toggle.setAttribute('data-origin-step-drawer-toggle', '');
toggle.setAttribute('aria-expanded', 'false');
toggle.setAttribute('aria-controls', nav.id);
toggle.setAttribute('aria-label', 'View all treatment days');
toggle.innerHTML = '<span class="origin-step-drawer-label"><span data-origin-step-drawer-kicker></span><strong data-origin-step-drawer-current></strong><em>Open the treatment day list to switch checkpoint.</em></span><span class="origin-step-drawer-meta"><span data-origin-step-drawer-marker></span><span class="origin-step-drawer-icon" data-origin-step-drawer-icon>View all treatment days</span></span>';
stepper.insertBefore(toggle, nav);

var intro = document.createElement('div');
intro.className = 'origin-step-drawer-intro';
intro.setAttribute('data-origin-step-drawer-intro', '');
intro.innerHTML = '<strong>All treatment days</strong><span>Choose a treatment day below. The selected video/photos will open underneath.</span>';
stepper.insertBefore(intro, nav);

toggle.addEventListener('click', function() {
setJourneyDrawerOpen(stepper, !stepper.classList.contains('is-step-drawer-open'));
});

stepper.querySelectorAll('[data-origin-step-tab]').forEach(function(tab) {
tab.addEventListener('click', function() {
window.requestAnimationFrame(function() {
updateJourneyDrawer(stepper);
setJourneyDrawerOpen(stepper, false);
if (stage && typeof stage.scrollIntoView === 'function') {
stage.scrollIntoView({ block: 'start', behavior: 'smooth' });
}
});
});
});

var tabObserver = new MutationObserver(function() {
updateJourneyDrawer(stepper);
});
stepper.querySelectorAll('[data-origin-step-tab]').forEach(function(tab) {
tabObserver.observe(tab, { attributes: true, attributeFilter: ['class', 'aria-selected'] });
});

var backdrop = stepper.closest('[data-origin-modal]');
if (backdrop) {
var modalObserver = new MutationObserver(function() {
if (backdrop.classList.contains('is-open')) {
setJourneyDrawerOpen(stepper, false);
window.requestAnimationFrame(function() {
updateJourneyDrawer(stepper);
});
}
});
modalObserver.observe(backdrop, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
}

updateJourneyDrawer(stepper);
setJourneyDrawerOpen(stepper, false);
});
}

function clickLikeUser(target) {
if (!target) return false;
try {
target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
return true;
} catch (error) {
if (typeof target.click === 'function') {
target.click();
return true;
}
}
return false;
}

function routeCardActionTarget(card, figure) {
if (!card) return null;
var targets = Array.prototype.slice.call(card.querySelectorAll('[data-origin-modal-open], [data-drsknn-booking-link]'));
return targets.find(function(target) {
return target !== figure && !figure.contains(target);
}) || null;
}

function initRouteImageActions() {
root.querySelectorAll('.origin-route-proof, .origin-correction-proof').forEach(function(figure) {
if (figure.getAttribute('data-origin-route-image-action') === 'true') return;
if (figure.hasAttribute('data-origin-modal-open')) {
figure.setAttribute('data-origin-route-image-action', 'native');
return;
}
var card = figure.closest('.origin-route-card, .origin-correction');
var target = routeCardActionTarget(card, figure);
if (!target) return;
figure.setAttribute('data-origin-route-image-action', 'true');
figure.setAttribute('role', 'button');
figure.setAttribute('tabindex', '0');
figure.setAttribute('aria-label', target.getAttribute('aria-label') || target.textContent.trim() || 'Open this Origin route');
figure.classList.add('origin-route-proof--clickable');

figure.addEventListener('click', function(event) {
event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();
clickLikeUser(target);
}, true);

figure.addEventListener('keydown', function(event) {
if (event.key !== 'Enter' && event.key !== ' ') return;
event.preventDefault();
event.stopPropagation();
clickLikeUser(target);
});
});
}

function initProofGalleryWheelNavigation() {
root.querySelectorAll('.origin-proof-gallery.is-carousel .origin-proof-carousel-stage').forEach(function(stage) {
if (stage.getAttribute('data-origin-wheel-carousel') === 'true') return;
stage.setAttribute('data-origin-wheel-carousel', 'true');
var gallery = stage.closest('.origin-proof-gallery');
var pending = false;

function move(delta) {
var button = gallery ? gallery.querySelector(delta > 0 ? '.origin-proof-gallery-nav--next' : '.origin-proof-gallery-nav--prev') : null;
if (button) clickLikeUser(button);
}

stage.addEventListener('wheel', function(event) {
var dominant = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
if (Math.abs(dominant) < 18) return;
event.preventDefault();
if (pending) return;
pending = true;
window.setTimeout(function() {
pending = false;
}, 180);
move(dominant > 0 ? 1 : -1);
}, { passive: false });
});
}

function enhanceLightboxZoom() {
var lightbox = root.querySelector('[data-origin-lightbox]');
var image = lightbox ? lightbox.querySelector('[data-origin-lightbox-image]') : null;
if (!lightbox || !image || image.getAttribute('data-origin-zoom-enhanced') === 'true') return;
image.setAttribute('data-origin-zoom-enhanced', 'true');

var scale = 1;
var offsetX = 0;
var offsetY = 0;
var mode = '';
var startX = 0;
var startY = 0;
var startOffsetX = 0;
var startOffsetY = 0;
var startScale = 1;
var startDistance = 0;
var lastTap = { time: 0, x: 0, y: 0 };

function clamp(value, min, max) {
return Math.max(min, Math.min(max, value));
}

function applyZoom() {
if (scale <= 1.01) {
scale = 1;
offsetX = 0;
offsetY = 0;
}
var maxX = window.innerWidth * Math.max(0, scale - 1);
var maxY = window.innerHeight * Math.max(0, scale - 1);
offsetX = clamp(offsetX, -maxX, maxX);
offsetY = clamp(offsetY, -maxY, maxY);
image.style.transform = 'translate3d(' + offsetX + 'px,' + offsetY + 'px,0) scale(' + scale + ')';
lightbox.classList.toggle('is-zoomed', scale > 1.01);
}

function resetZoom() {
scale = 1;
offsetX = 0;
offsetY = 0;
applyZoom();
}

function distance(touches) {
var dx = touches[0].clientX - touches[1].clientX;
var dy = touches[0].clientY - touches[1].clientY;
return Math.sqrt(dx * dx + dy * dy);
}

function setScale(nextScale) {
scale = clamp(nextScale, 1, 4);
applyZoom();
}

function toggleZoom(point) {
if (scale > 1.01) {
resetZoom();
return;
}
offsetX = point ? (window.innerWidth / 2 - point.clientX) * 0.55 : 0;
offsetY = point ? (window.innerHeight / 2 - point.clientY) * 0.55 : 0;
setScale(2.35);
}

image.addEventListener('dblclick', function(event) {
event.preventDefault();
toggleZoom(event);
});

lightbox.addEventListener('wheel', function(event) {
if (!lightbox.classList.contains('is-open')) return;
event.preventDefault();
setScale(scale + (event.deltaY < 0 ? 0.28 : -0.28));
}, { passive: false });

image.addEventListener('touchstart', function(event) {
if (!lightbox.classList.contains('is-open')) return;
if (event.touches.length === 2) {
mode = 'pinch';
startDistance = distance(event.touches);
startScale = scale;
event.preventDefault();
return;
}
if (event.touches.length === 1) {
var touch = event.touches[0];
mode = scale > 1.01 ? 'pan' : 'tap';
startX = touch.clientX;
startY = touch.clientY;
startOffsetX = offsetX;
startOffsetY = offsetY;
}
}, { passive: false });

image.addEventListener('touchmove', function(event) {
if (mode === 'pinch' && event.touches.length === 2) {
event.preventDefault();
setScale(startScale * (distance(event.touches) / Math.max(1, startDistance)));
return;
}
if (mode === 'pan' && event.touches.length === 1 && scale > 1.01) {
event.preventDefault();
offsetX = startOffsetX + event.touches[0].clientX - startX;
offsetY = startOffsetY + event.touches[0].clientY - startY;
applyZoom();
}
}, { passive: false });

image.addEventListener('touchend', function(event) {
if (mode === 'tap' && event.changedTouches.length) {
var touch = event.changedTouches[0];
var moved = Math.abs(touch.clientX - startX) + Math.abs(touch.clientY - startY);
var now = Date.now();
if (moved < 22 && now - lastTap.time < 320 && Math.abs(touch.clientX - lastTap.x) < 32 && Math.abs(touch.clientY - lastTap.y) < 32) {
event.preventDefault();
toggleZoom(touch);
lastTap.time = 0;
} else {
lastTap = { time: now, x: touch.clientX, y: touch.clientY };
}
}
mode = '';
});

image.addEventListener('pointerdown', function(event) {
if (scale <= 1.01 || event.pointerType !== 'mouse') return;
event.preventDefault();
event.stopPropagation();
mode = 'mouse-pan';
startX = event.clientX;
startY = event.clientY;
startOffsetX = offsetX;
startOffsetY = offsetY;
try { image.setPointerCapture(event.pointerId); } catch (error) {}
}, true);

image.addEventListener('pointermove', function(event) {
if (mode !== 'mouse-pan') return;
event.preventDefault();
offsetX = startOffsetX + event.clientX - startX;
offsetY = startOffsetY + event.clientY - startY;
applyZoom();
}, true);

image.addEventListener('pointerup', function(event) {
if (mode !== 'mouse-pan') return;
event.preventDefault();
event.stopPropagation();
mode = '';
try { image.releasePointerCapture(event.pointerId); } catch (error) {}
}, true);

new MutationObserver(resetZoom).observe(image, { attributes: true, attributeFilter: ['src'] });
window.addEventListener('resize', resetZoom);
resetZoom();
}

var scrollCaptionCache = {};

function parseVttTime(value) {
var parts = value.trim().split(':');
var seconds = 0;
if (parts.length === 3) seconds += Number(parts.shift()) * 3600;
if (parts.length === 2) seconds += Number(parts.shift()) * 60;
seconds += Number((parts.shift() || '0').replace(',', '.'));
return Number.isFinite(seconds) ? seconds : 0;
}

function parseVtt(text) {
return text.replace(/\r/g, '').split(/\n\n+/).map(function(block) {
var lines = block.split('\n').filter(function(line) { return line.trim(); });
var timeLineIndex = lines.findIndex(function(line) { return line.indexOf('-->') !== -1; });
if (timeLineIndex === -1) return null;
var times = lines[timeLineIndex].split('-->');
var caption = lines.slice(timeLineIndex + 1).join('\n').trim();
if (!caption) return null;
return {
start: parseVttTime(times[0]),
end: parseVttTime(times[1]),
text: caption
};
}).filter(Boolean);
}

function loadScrollCaptionCues(src) {
if (!src) return Promise.resolve([]);
if (!scrollCaptionCache[src]) {
scrollCaptionCache[src] = fetch(src)
.then(function(response) {
if (!response.ok) throw new Error('Caption request failed');
return response.text();
})
.then(parseVtt)
.catch(function() { return []; });
}
return scrollCaptionCache[src];
}

function cueAtTime(cues, time) {
for (var index = 0; index < cues.length; index += 1) {
if (time >= cues[index].start && time <= cues[index].end) return cues[index];
}
return null;
}

function cleanCaptionText(text) {
return String(text || '')
.replace(/<[^>]+>/g, '')
.replace(/&amp;/g, '&')
.replace(/&lt;/g, '<')
.replace(/&gt;/g, '>')
.replace(/&quot;/g, '"')
.replace(/&#39;/g, "'")
.replace(/\n{3,}/g, '\n\n')
.trim();
}

function captionSrcForVideo(video) {
if (!video) return '';
var explicit = video.getAttribute('data-origin-caption-src');
if (explicit) return explicit;
var tracks = Array.prototype.slice.call(video.querySelectorAll('track'));
var track = tracks.find(function(item) {
var kind = (item.getAttribute('kind') || '').toLowerCase();
return (kind === 'captions' || kind === 'subtitles') && item.getAttribute('src');
});
return track ? track.src || track.getAttribute('src') || '' : '';
}

function captionContainerForVideo(video) {
return video.closest('.origin-video-frame') ||
video.closest('.origin-journey-preview') ||
video.closest('.origin-floating-video-modal') ||
video.closest('.origin-floating-video-card') ||
video.parentElement;
}

function hideNativeCaptionTracks(video) {
if (!video || !video.textTracks) return;
for (var index = 0; index < video.textTracks.length; index += 1) {
var track = video.textTracks[index];
if (track.kind === 'captions' || track.kind === 'subtitles') {
track.mode = 'hidden';
}
}
}

function initScrollCaptions() {
var videos = Array.prototype.slice.call(root.querySelectorAll('video')).filter(function(video) {
return !video.hasAttribute('data-origin-floating-video-mini') && !!captionSrcForVideo(video);
});
if (!videos.length) return;
var visibleVideos = new WeakSet();
var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries) {
entries.forEach(function(entry) {
var overlay = entry.target._originScrollCaptionOverlay;
if (entry.isIntersecting && entry.intersectionRatio > 0.35) {
visibleVideos.add(entry.target);
} else {
visibleVideos.delete(entry.target);
if (overlay) {
overlay.textContent = '';
overlay.classList.remove('is-active');
}
}
});
}, { threshold: [0, 0.35, 0.7] }) : null;

videos.forEach(function(video) {
if (video.getAttribute('data-origin-custom-captions') === 'true') {
hideNativeCaptionTracks(video);
return;
}
var src = captionSrcForVideo(video);
var container = video.closest('.origin-journey-preview') || video.parentElement;
container = captionContainerForVideo(video);
if (!src || !container) return;
video.setAttribute('data-origin-custom-captions', 'true');
hideNativeCaptionTracks(video);
if (window.getComputedStyle(container).position === 'static') {
container.style.position = 'relative';
}
var overlay = container.querySelector('.origin-scroll-caption');
if (!overlay) {
overlay = document.createElement('div');
overlay.className = 'origin-scroll-caption origin-custom-video-caption';
overlay.setAttribute('aria-hidden', 'true');
container.appendChild(overlay);
}
video._originScrollCaptionOverlay = overlay;
if (observer) observer.observe(video);
else visibleVideos.add(video);

loadScrollCaptionCues(src).then(function(cues) {
function updateCaption() {
hideNativeCaptionTracks(video);
if (!visibleVideos.has(video) || !cues.length) {
overlay.textContent = '';
overlay.classList.remove('is-active');
return;
}
var duration = video.duration || 0;
var time = duration > 0 ? video.currentTime % duration : video.currentTime;
var cue = cueAtTime(cues, time);
if (cue) {
overlay.textContent = cleanCaptionText(cue.text);
overlay.classList.add('is-active');
} else {
overlay.textContent = '';
overlay.classList.remove('is-active');
}
}
video.addEventListener('timeupdate', updateCaption);
video.addEventListener('play', updateCaption);
video.addEventListener('playing', updateCaption);
video.addEventListener('pause', updateCaption);
video.addEventListener('seeked', updateCaption);
video.addEventListener('loadedmetadata', updateCaption);
video.addEventListener('loadeddata', updateCaption);
video.addEventListener('durationchange', updateCaption);
updateCaption();
});
});
}

function enableVideoCaptionTracks() {
root.querySelectorAll('video').forEach(function(video) {
hideNativeCaptionTracks(video);
});
}

function init() {
addAreaNotes();
initPhotoAccordions();
syncStepLabels();
initJourneyDrawers();
initRouteImageActions();
initProofGalleryWheelNavigation();
enableVideoCaptionTracks();
initScrollCaptions();
enhanceLightboxZoom();
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
}());
